<template>
  <d-list-group flush>
    <d-list-group-item class="p-3 table-overflow">
      <d-form @submit.prevent="save">
        <d-form-row>

          <!-- Nome -->
          <d-col md="8" class="form-group autocomplete">
            <label for="name">
              Cliente
              <span class="link" @click.prevent="addNewClient()">Adicionar novo cliente</span>
            </label>
            <autocomplete
              ref="autocomplete"
              placeholder="Cliente"
              :state="hasErrorField('customer_name')"
              :items="customers"
              item-show="name"
              :on-input="onInput"
              :on-select="setQuotationCustomer"
              :on-show-text="showText"
              showIconClear
            />
          </d-col>

          <!-- Valid at -->
          <d-col md="2" class="form-group">
            <label>Validade</label>
            <datepicker :model.sync="model.valid_at"/>
          </d-col>

          <!-- Status -->
          <d-col md="2" class="form-group">
            <label>Status</label>
            <d-select v-model="model.status">
              <option :value="option.slug" v-for="option in statusOptions" :key="option.id">{{ option.name }}</option>
            </d-select>
          </d-col>

        </d-form-row>

        <d-form-row v-if="model.customer && model.customer.addresses.length > 1">
          <d-col cols="6">
            <label>Endereço do serviço</label>
            <d-select
              v-model="model.service_address_id"
              :options="model.customer.addresses"
              value-field="id"
              text-field="label"
            >
            </d-select>
          </d-col>
        </d-form-row>

        <!-- Product Table -->
        <d-form-row class="mt-4 mb-1">
          <d-col>
            <h5>Agentes</h5>
            <table class="table table-striped table-bordered" role="table" v-if="model">
              <thead class="bg-light" role="rowgroup">
                <tr role="row">
                  <th role="columnheader" class="text-center">ID</th>
                  <th role="columnheader">Avaliação</th>
                  <th role="columnheader">Agentes</th>
                  <th role="columnheader" class="text-center">Setor</th>
                  <th role="columnheader" class="text-center">Função</th>
                  <th role="columnheader" class="text-center">Tipo Exposição</th>
                  <th role="columnheader" class="text-center">Exposição</th>
                  <th role="columnheader" class="text-center">Qtd.</th>
                  <th role="columnheader" class="text-right">Valor un.</th>
                  <th role="columnheader" class="text-right">Total</th>
                  <th role="columnheader" class="text-right"></th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                <tr role="row" v-for="(item, navItemId) in model.rows" :key="navItemId">
                  <td role="cell" class="td-1">
                    <span class="mt-2 text-center d-block">{{navItemId + 1}}</span>
                  </td>
                  <td role="cell" class="td-3">
                    <d-select
                      v-model="item.product_type_id"
                      :options="productType"
                      value-field="id"
                      text-field="name"
                    >
                    </d-select>
                  </td>
                  <td role="cell" class="td-5">
                    <autocomplete
                      :ref="`autocompleteProduct_${navItemId}`"
                      placeholder="Agentes"
                      :items="products"
                      item-show="display_name"
                      :parameter="{item, navItemId}"
                      :on-input="onInputProduct"
                      :on-select="setProductQuotationRow"
                      showIconClear
                    />
                  </td>
                  <td role="cell" class="td-3">
                    <input type="text" class="text-left form-control" placeholder="Setor" v-model="item.sector" required/>
                  </td>
                  <td role="cell" class="td-3">
                    <input type="text" class="text-left form-control" placeholder="Função" v-model="item.function" required/>
                  </td>
                  <td role="cell" class="td-3">
                    <d-select
                      v-model="item.exposition_type_id"
                      :options="expositionType"
                      value-field="id"
                      text-field="name"
                    >
                    </d-select>
                  </td>
                  <td role="cell" class="td-2">
                    <input type="text" class="text-center form-control" placeholder="Exposição" v-model="item.daily_exposition" required/>
                  </td>
                  <td role="cell" class="td-2">
                    <input type="number" class="text-center form-control" placeholder="Qtd." v-model="item.quantity" @change="setQuantity(item)" required/>
                  </td>
                  <td role="cell" class="td-3">
                    <d-input-group prepend="R$">
                      <input-currency
                        model-index="value"
                        placeholder="Valor"
                        :model="item"
                        :on-change="setTotal"
                      ></input-currency>
                    </d-input-group>
                  </td>
                  <td role="cell" class="td-3">
                    <d-input-group prepend="R$">
                      <input-currency
                        model-index="total"
                        placeholder="Total"
                        :model="item"
                        :on-change="setUnitValor"
                      ></input-currency>
                    </d-input-group>
                  </td>
                  <td role="cell" class="td-1 td">
                    <div class="buttons">
                      <i class="fas fa-plus text-success" @click="addRow()" v-if="navItemId+1 == model.rows.length"></i>
                      <i class="fas fa-minus text-danger" @click="removeRow(navItemId)" v-if="model.rows.length > 1"></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </d-col>
        </d-form-row>

        <!-- Service Table -->
        <quotation-other-items-table
          title="Serviços"
          ref="servicesTable"
          slug="services"
          :model="model.services"
          :items="services"
          :addRow="addRow"
          :removeRow="removeRow"
          :on-input="onInputService"
          :on-select="setProductQuotationRow"
          :set-quantity="setQuantity"
          :set-total="setTotal"
          :set-unit-valor="setUnitValor"
        />

        <!-- Cost Table -->
        <quotation-other-items-table
          title="Outros custos"
          ref="costsTable"
          slug="costs"
          :model="model.costs"
          :items="costs"
          :addRow="addRow"
          :removeRow="removeRow"
          :on-input="onInputCost"
          :on-select="setProductQuotationRow"
          :set-quantity="setQuantity"
          :set-total="setTotal"
          :set-unit-valor="setUnitValor"
        />

        <d-form-row class="justify-content-end">

          <!-- Subtotal -->
          <d-col md="12" lg="4" xl="2" cols="12" class="form-group">
            <label for="feSubtotal">Subtotal</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="subtotal"
                placeholder="Subotal"
                :model="model"
                :on-change="setUnitValor"
                readonly
              ></input-currency>
            </d-input-group>
          </d-col>

          <!-- Desconto -->
          <d-col md="12" lg="4" xl="2" cols="12" class="mb-0 form-group">
            <label for="feDesconto">Desconto</label>
            <d-input-group class="mb-3 discount">
              <d-input-group-addon prepend>
                <select class="input-group-text form-control custom-select" v-model="model.discount_type" @change="setQuotationTotal()">
                  <option value="pct" selected>%</option>
                  <option value="value">R$</option>
                </select>
              </d-input-group-addon>
              <input-currency
                model-index="discount"
                placeholder="Desconto"
                hiddenGroup=""
                :model="model"
                :on-change="setQuotationTotal"
              ></input-currency>
            </d-input-group>
          </d-col>

          <!-- Total -->
          <d-col md="12" lg="4" xl="2" cols="12" class="form-group">
            <label for="feTotal">Total</label>
            <d-input-group prepend="R$" :class="['is-' + hasErrorField('total')]">
              <input-currency
                model-index="total"
                placeholder="Total"
                :state="hasErrorField('total')"
                :model="model"
                :on-change="setQuotationDiscount"
              ></input-currency>
              <d-form-invalid-feedback>Total é obrigatório</d-form-invalid-feedback>
            </d-input-group>
          </d-col>

        </d-form-row>

        <d-form-row class="justify-content-end">

          <!-- Condição de pagamento -->
          <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
            <label for="fePagto">Cond. pagamento</label>
            <d-select v-model="model.payment_id">
              <option :value="option.id" v-for="option in paymentTypeOptions" :key="option.id">{{ option.name }}</option>
            </d-select>
          </d-col>

          <!-- Quantidade de parcelas -->
          <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
            <label for="fePagto">Parcelas</label>
            <d-form-input type="number" id="fePagto" class="text-right" min="1" v-model="model.parcel" @change="setPortionValue()"/>
          </d-col>

          <!-- Valor da parcela -->
          <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
            <label for="feParcela">Valor da parcela</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="parcel_value"
                placeholder="R$ 0,00"
                :model="model"
                :on-change="setUnitValor"
              ></input-currency>
            </d-input-group>
          </d-col>

          <div class="w-100 d-none d-xl-block d-lg-none"></div>

          <!-- Seller -->
           <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
            <label>Vendedor</label>
            <select-seller :model.sync="model.created_by" v-if="isAdmin" ></select-seller>
            <d-form-input type="text" v-model="model.user.name" readonly v-else/>
          </d-col>

          <!-- Forma de pagamento -->
          <d-col md="12" lg="12" xl="4" cols="12" class="form-group">
            <label for="fePagtoInfo">Forma de pagamento</label>
            <d-form-input type="text" id="fePagtoInfo" class="text-left" v-model="model.payment_info"/>
          </d-col>

        </d-form-row>

        <d-form-row>
          <quotation-equipments :model.sync="model" v-if="model"/>
          <quotation-deadlines :model.sync="model" v-if="model.deadlines"/>
        </d-form-row>

        <!-- Quotation details -->
        <d-form-row>
          <d-col cols="12" class="form-group">
            <label>Detalhes <small>(Não remover as variaveis do texto)</small> <span class="link" @click.prevent="setDefaultQuotationDetailsBySettings()">Inserir o texto padrão</span></label>
            <editor :model.sync="model.details" v-if="model"/>
          </d-col>
        </d-form-row>

        <!-- Comments -->
        <d-form-row>
          <d-col md="12" class="form-group">
            <label for="feComentarios">
              Comentários
              <span class="link" @click.prevent="capitalizeField('comment', true)">Formatar texto</span>
            </label>
            <d-checkbox v-model="autoCapitalize" class="float-right" ><small>Auto Formatar</small></d-checkbox>
            <textarea
              v-model="model.comment"
              name="feComentarios"
              rows="5"
              class="form-control"
              @change="autoCapitalizeField('comment')"
            ></textarea>
          </d-col>

        </d-form-row>

        <d-button type="submit" class="btn-accent">Salvar</d-button>

      </d-form>
    </d-list-group-item>
    <add-customer-modal/>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Editor from '_shared/Editor.vue';
import MixinDate from '_common/mixins/Date';
import formatErrors from '_common/mixins/FormatErrors';
import Datepicker from '_shared/Datepicker.vue';
import SelectSeller from '_shared/SelectSeller.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import InputCurrency from '_shared/InputCurrency.vue';
import AddCustomerModal from '_modules/quotation/components/modal/AddCustomerModal.vue';
import QuotationService from '_services/rest/modules/quotation';
import MixinValidateForm from '_common/mixins/ValidateForm';
import QuotationDeadlines from '_modules/quotation/components/QuotationDeadlines.vue';
import QuotationEquipments from '_modules/quotation/components/QuotationEquipments.vue';
import MixinQuotationCalc from '_common/mixins/QuotationCalc';
import { _SAVE_CUSTOMER_SUCCESS_ } from '_modules/customer/components/CustomerModel';
import { getDateTimeISO, capitalize, capitalizePhrase, firstLetterUppercase, cloneDeep } from '_utils';
import { EQUIPMENT_DEFAULT } from '_constants/equipment';
import {
  ROW,
  MODEL,
  STATUS_OPTIONS,
  PAYMENT_TYPE_OPTIONS,
  EXPOSITION_TYPE_OPTIONS,
  _LOAD_MODEL_,
  _FINISHED_SAVE_REQUEST_,
  _UPDATE_QUOTATION_ROWS_,
  _UPDATE_QUOTATION_PRODUCT_,
  SPECIAL_TYPE_ROW,
  MODEL_QUOTATION_EQUIPMENT,
} from './QuotationModel';
import QuotationOtherItemsTable from './QuotationOtherItemsTable.vue';

export default {
  name: 'quotation-form',
  mixins: [MixinQuotationCalc, MixinValidateForm, MixinDate, formatErrors],
  components: {
    Editor,
    Datepicker,
    Autocomplete,
    SelectSeller,
    InputCurrency,
    AddCustomerModal,
    QuotationEquipments,
    QuotationDeadlines,
    QuotationOtherItemsTable,
  },
  data() {
    return {
      model: { ...MODEL },
      items: [],
      loading: false,
      statusOptions: STATUS_OPTIONS,
      autoCapitalize: true,
      selectedRowIndex: 0,
      errors: {
        customer_name: { required: false },
        total: { required: false },
      },
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    customers() {
      const { customerList } = this.$store.state.customer;
      if (customerList && customerList.list.length) {
        return customerList.list;
      }
      return [];
    },
    products() {
      const { productList } = this.$store.state.product;
      if (productList && productList.list.length) {
        return productList.list;
      }
      return [];
    },
    services() {
      const { serviceList } = this.$store.state.service;
      if (serviceList && serviceList.list.length) {
        return serviceList.list;
      }
      return [];
    },
    costs() {
      const { costList } = this.$store.state.cost;
      if (costList && costList.list.length) {
        return costList.list;
      }
      return [];
    },
    paymentTypeOptions() {
      const { paymentTypeOptions } = this.$store.state.quotation;
      if (paymentTypeOptions && paymentTypeOptions.length) {
        return paymentTypeOptions;
      }
      return PAYMENT_TYPE_OPTIONS;
    },
    expositionType() {
      const { expositionType } = this.$store.state.quotation;
      if (expositionType && expositionType.length) {
        return expositionType;
      }
      return EXPOSITION_TYPE_OPTIONS;
    },
    productType() {
      const { productType } = this.$store.state.product;
      if (productType && productType.length) {
        return productType;
      }
      return [{ ...EQUIPMENT_DEFAULT }];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'checkAdmin',
      'activeAlert',
      'getSettings',
      'getCostList',
      'getServiceList',
      'getProductList',
      'getProductType',
      'getCustomerList',
      'getExpositionType',
      'getPaymentTypeOptions',
    ]),
    addRow(list = 'rows') {
      const model = list === 'rows' ? ROW : SPECIAL_TYPE_ROW;
      this.model[list].push({ ...model });
      setTimeout(() => {
        this.calcSubtotal();
      }, 50);
    },
    autoCapitalizeField(field) {
      if (this.autoCapitalize) {
        this.model[field] = capitalize(this.model[field]);
      }
    },
    addNewClient() {
      this.setToggle({ type: 'add_customer_modal', bool: true });
    },
    capitalizeComment() {
      this.model.comment = firstLetterUppercase(this.model.comment);
    },
    capitalizeField(field, phrase = false) {
      if (phrase) {
        this.model[field] = capitalizePhrase(this.model[field]);
        return true;
      }
      this.model[field] = capitalize(this.model[field]);
      return true;
    },
    cleanEmptyRows() {
      this.model.rows = this.model.rows.filter(row => row.product_id);
    },
    getListCustomer(name = '') {
      this.toggleLoading();
      const params = {
        skip: 0,
        take: 10,
        search: name,
      };
      this.getCustomerList(params)
        .then(() => {
          this.toggleLoading();
        });
    },
    getOptions() {
      if (!this.$store.state.quotation.expositionType) {
        this.setToggle({ type: 'progress', bool: true });
        this.getExpositionType()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
      if (!this.$store.state.quotation.paymentTypeOptions) {
        this.setToggle({ type: 'progress', bool: true });
        this.getPaymentTypeOptions()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
      if (!this.$store.state.product.productType) {
        this.setToggle({ type: 'progress', bool: true });
        this.getProductType()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
      if (!this.$store.state.settings.messages) {
        this.getSettings()
          .then(() => {
            setTimeout(() => {
              this.setDefaultQuotationDetailsBySettings();
              this.setDefaultQuotationDeadlinesBySettings();
            }, 30);
          });
      }
    },
    onInput(name) {
      this.getListCustomer(name);
    },
    getProductTypeSlugById(id) {
      const type = this.productType.find(item => item.id === id);
      return type.slug;
    },
    handleInput(name, slug, fetchMethod) {
      const filter = {
        search: name,
        skip: 0,
        take: 10,
        slug,
      };
      fetchMethod(filter);
    },
    onInputProduct(name, params) {
      const slug = this.getProductTypeSlugById(params.item.product_type_id);
      this.handleInput(name, slug, this.getProductList);
    },
    onInputService(name) {
      this.handleInput(name, 'service', this.getServiceList);
    },
    onInputCost(name) {
      this.handleInput(name, 'cost', this.getCostList);
    },
    removeRow(index, list = 'rows') {
      this.model[list].splice(index, 1);
      Events.$emit(_UPDATE_QUOTATION_PRODUCT_);
      setTimeout(() => {
        this.calcSubtotal();
      }, 50);
    },
    save() {
      if (this.checkForm()) {
        this.cleanEmptyRows();
        this.toggleLoading();
        this.model.valid_at = getDateTimeISO(this.model.valid_at);
        // TODO:: Make responsible fields
        this.model.responsible = 'Teste';
        QuotationService.save(this.model)
          .then(response => this.success(response))
          .catch(error => {
            this.toggleLoading();
            this.showError(error);
          });
      }
      return null;
    },
    setCustomer(customer) {
      if (this.$refs.autocomplete) {
        this.$refs.autocomplete.$refs.input.value = customer.name;
      }
    },
    setQuantity(item) {
      Events.$emit(_UPDATE_QUOTATION_PRODUCT_);
      this.setTotal(item);
    },
    setDefaultQuotationDeadlinesBySettings() {
      if (this.model.deadlines === null) {
        const { deadlines } = this.$store.state.settings.messages;
        this.model.deadlines = deadlines;
      }
    },
    setDefaultQuotationDetailsBySettings() {
      if (!this.model.details) {
        const { quotationDetails } = this.$store.state.settings.messages;
        this.model.details = quotationDetails;
      }
    },
    setProductInAutocomplete() {
      this.model.rows.map((row, index) => {
        if (this.$refs[`autocompleteProduct_${index}`][0] && row.product.name) {
          this.$refs[`autocompleteProduct_${index}`][0].$refs.input.value = row.product.display_name;
        }
        return row;
      });
    },
    setAutocompleteValues(table) {
      this.$refs[table].setAutocompleteValues();
    },
    setProductQuotationRow(product, { item }) {
      if (item) {
        item.product = product || null;
        item.product_id = product?.id || null;
        item.value = product?.price || ROW.value;
        item.unit_type = product?.unit_type || null;
        item.quantity = product?.quantity || ROW.quantity;
        item.product_type_id = product?.type_id ?? item.product_type_id;
        Events.$emit(_UPDATE_QUOTATION_PRODUCT_, {
          product,
          quantity: item.quantity,
        });
        this.setTotal(item);
      }
    },
    setQuotationCustomer(customer) {
      this.model.customer = customer;
      this.model.customer_id = customer.id;
      this.model.customer_name = customer.name;
    },
    showText(item) {
      return `${item.name} <strong class="document">${item.document}</strong>`;
    },
    success(quotation) {
      this.model = quotation;
      this.$store.commit('setQuotation', quotation);
      this.toggleLoading();
      this.activeAlert({ message: 'Orçamento salvo com sucesso', theme: 'success' });
      Events.$emit(_FINISHED_SAVE_REQUEST_, quotation);
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    addInitialRowIfEmpty(field, defaultValue) {
      if (!this.model[field] || this.model[field].length === 0) {
        this.model[field] = [cloneDeep(defaultValue)];
      }
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = newValue;
      this.addInitialRowIfEmpty('services', SPECIAL_TYPE_ROW);
      this.addInitialRowIfEmpty('costs', SPECIAL_TYPE_ROW);
      this.addInitialRowIfEmpty('equipments', MODEL_QUOTATION_EQUIPMENT);
      setTimeout(() => {
        this.setCustomer(newValue.customer);
        this.setProductInAutocomplete();
        this.setAutocompleteValues('servicesTable');
        this.setAutocompleteValues('costsTable');
      }, 50);
    });
    Events.$on(_SAVE_CUSTOMER_SUCCESS_, customer => {
      this.setToggle({ type: 'add_customer_modal', bool: false });
      this.setCustomer(customer);
      this.setQuotationCustomer(customer);
    });
    Events.$on(_FINISHED_SAVE_REQUEST_, quotation => {
      this.$router.push(`/admin/orcamentos/${quotation.id}`);
    });
    Events.$on(_UPDATE_QUOTATION_ROWS_, row => {
      this.$set(this.model.rows, this.selectedRowIndex, row);
      setTimeout(() => {
        this.calcSubtotal(this.model.rows[this.selectedRowIndex]);
      }, 50);
    });
    this.getOptions();
    this.checkAdmin();
  },
};
</script>
<style lang="scss" scoped>
@import '~_scss/overrides';
@import '~_scss/table';
</style>
